/* Made based on poi.xml in finn/map */

export enum PoiTypes {
    /* Transport */
    AVINOR_AIRPORT = 42501,
    CHARGING_STATION = 30001,
    ENTUR_AIRPORT = 101100,
    ENTUR_BUS = 100700,
    ENTUR_FERRY = 101000,
    ENTUR_SUBWAY = 100401,
    ENTUR_TRAIN = 100100,
    ENTUR_TRAM = 100900,

    /* Health and education */
    SCHOOL_ELEMENTARY = 401,
    SCHOOL_MIDDLE = 402,
    SCHOOL_HIGH = 500,
    KINDERGARDEN = 600,
    HOSPITAL = 2000,

    /* Tourism */
    TRAVEL = 737,
    TOURIST_ATTRACTION = 7999,
    MUSEUM = 8410,

    /* Stores */
    SHOPPING_CENTRE = 700,
    STORE = 1100,
    POST_OFFICE = 800,
    PHARMACY = 900,
    VINMONOPOL = 1000,
    KIOSK = 1200,
    GAS_STATION = 1300,

    /* Activities */
    SPORTS_FACILITY = 310,
    GYM = 330,
    SKI_CENTRE = 7012,

    /* Waste management */
    RECYCLING_STATION = 3010,
    WASTE_DISPOSAL = 3011,
    DANGEROUS_WASTE_DISPOSAL = 3012,
    CABIN_WASTE_DISPOSAL = 3013,
    BOAT_WASTE_DISPOSAL = 3014,
}
